import * as React from "react";
import useBackdropController from "./useBackdropController";
import BackdropOverlay from "./Backdrop";
import OverlayContext from "./Context";
import { SpinnerBox } from "../Spinner";

const Provider = ({
  children,
  spinner,
  position
}) => {
  const [open, show, hide, showWhile] = useBackdropController();
  const contextValue = React.useMemo(() => ({
    show,
    hide,
    showWhile,
    position
  }), [show, hide, showWhile, position]);
  return /*#__PURE__*/React.createElement(OverlayContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(BackdropOverlay, {
    open: open,
    spinner: spinner
  }));
};

Provider.defaultProps = {
  spinner: () => /*#__PURE__*/React.createElement(SpinnerBox, null)
};
export default Provider;